/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TrendsRouteImport } from './routes/trends'
import { Route as TransactionsRouteImport } from './routes/transactions'
import { Route as TagsDashboardRouteImport } from './routes/tags-dashboard'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LinkWhatsappRouteImport } from './routes/link-whatsapp'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as IncomeSourcesRouteImport } from './routes/income-sources'
import { Route as FixedExpensesRouteImport } from './routes/fixed-expenses'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CsvImportRouteImport } from './routes/csv-import'
import { Route as CategoriesRouteImport } from './routes/categories'
import { Route as CashflowRouteImport } from './routes/cashflow'
import { Route as BudgetsRouteImport } from './routes/budgets'
import { Route as AiChatRouteImport } from './routes/ai-chat'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CategoriesAnalysisRouteImport } from './routes/categories/analysis'

const TrendsRoute = TrendsRouteImport.update({
  id: '/trends',
  path: '/trends',
  getParentRoute: () => rootRouteImport,
} as any)
const TransactionsRoute = TransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => rootRouteImport,
} as any)
const TagsDashboardRoute = TagsDashboardRouteImport.update({
  id: '/tags-dashboard',
  path: '/tags-dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LinkWhatsappRoute = LinkWhatsappRouteImport.update({
  id: '/link-whatsapp',
  path: '/link-whatsapp',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const IncomeSourcesRoute = IncomeSourcesRouteImport.update({
  id: '/income-sources',
  path: '/income-sources',
  getParentRoute: () => rootRouteImport,
} as any)
const FixedExpensesRoute = FixedExpensesRouteImport.update({
  id: '/fixed-expenses',
  path: '/fixed-expenses',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CsvImportRoute = CsvImportRouteImport.update({
  id: '/csv-import',
  path: '/csv-import',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoriesRoute = CategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => rootRouteImport,
} as any)
const CashflowRoute = CashflowRouteImport.update({
  id: '/cashflow',
  path: '/cashflow',
  getParentRoute: () => rootRouteImport,
} as any)
const BudgetsRoute = BudgetsRouteImport.update({
  id: '/budgets',
  path: '/budgets',
  getParentRoute: () => rootRouteImport,
} as any)
const AiChatRoute = AiChatRouteImport.update({
  id: '/ai-chat',
  path: '/ai-chat',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoriesAnalysisRoute = CategoriesAnalysisRouteImport.update({
  id: '/analysis',
  path: '/analysis',
  getParentRoute: () => CategoriesRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/ai-chat': typeof AiChatRoute
  '/budgets': typeof BudgetsRoute
  '/cashflow': typeof CashflowRoute
  '/categories': typeof CategoriesRouteWithChildren
  '/csv-import': typeof CsvImportRoute
  '/dashboard': typeof DashboardRoute
  '/fixed-expenses': typeof FixedExpensesRoute
  '/income-sources': typeof IncomeSourcesRoute
  '/invite': typeof InviteRoute
  '/link-whatsapp': typeof LinkWhatsappRoute
  '/login': typeof LoginRoute
  '/settings': typeof SettingsRoute
  '/tags-dashboard': typeof TagsDashboardRoute
  '/transactions': typeof TransactionsRoute
  '/trends': typeof TrendsRoute
  '/categories/analysis': typeof CategoriesAnalysisRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/ai-chat': typeof AiChatRoute
  '/budgets': typeof BudgetsRoute
  '/cashflow': typeof CashflowRoute
  '/categories': typeof CategoriesRouteWithChildren
  '/csv-import': typeof CsvImportRoute
  '/dashboard': typeof DashboardRoute
  '/fixed-expenses': typeof FixedExpensesRoute
  '/income-sources': typeof IncomeSourcesRoute
  '/invite': typeof InviteRoute
  '/link-whatsapp': typeof LinkWhatsappRoute
  '/login': typeof LoginRoute
  '/settings': typeof SettingsRoute
  '/tags-dashboard': typeof TagsDashboardRoute
  '/transactions': typeof TransactionsRoute
  '/trends': typeof TrendsRoute
  '/categories/analysis': typeof CategoriesAnalysisRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/ai-chat': typeof AiChatRoute
  '/budgets': typeof BudgetsRoute
  '/cashflow': typeof CashflowRoute
  '/categories': typeof CategoriesRouteWithChildren
  '/csv-import': typeof CsvImportRoute
  '/dashboard': typeof DashboardRoute
  '/fixed-expenses': typeof FixedExpensesRoute
  '/income-sources': typeof IncomeSourcesRoute
  '/invite': typeof InviteRoute
  '/link-whatsapp': typeof LinkWhatsappRoute
  '/login': typeof LoginRoute
  '/settings': typeof SettingsRoute
  '/tags-dashboard': typeof TagsDashboardRoute
  '/transactions': typeof TransactionsRoute
  '/trends': typeof TrendsRoute
  '/categories/analysis': typeof CategoriesAnalysisRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ai-chat'
    | '/budgets'
    | '/cashflow'
    | '/categories'
    | '/csv-import'
    | '/dashboard'
    | '/fixed-expenses'
    | '/income-sources'
    | '/invite'
    | '/link-whatsapp'
    | '/login'
    | '/settings'
    | '/tags-dashboard'
    | '/transactions'
    | '/trends'
    | '/categories/analysis'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ai-chat'
    | '/budgets'
    | '/cashflow'
    | '/categories'
    | '/csv-import'
    | '/dashboard'
    | '/fixed-expenses'
    | '/income-sources'
    | '/invite'
    | '/link-whatsapp'
    | '/login'
    | '/settings'
    | '/tags-dashboard'
    | '/transactions'
    | '/trends'
    | '/categories/analysis'
  id:
    | '__root__'
    | '/'
    | '/ai-chat'
    | '/budgets'
    | '/cashflow'
    | '/categories'
    | '/csv-import'
    | '/dashboard'
    | '/fixed-expenses'
    | '/income-sources'
    | '/invite'
    | '/link-whatsapp'
    | '/login'
    | '/settings'
    | '/tags-dashboard'
    | '/transactions'
    | '/trends'
    | '/categories/analysis'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AiChatRoute: typeof AiChatRoute
  BudgetsRoute: typeof BudgetsRoute
  CashflowRoute: typeof CashflowRoute
  CategoriesRoute: typeof CategoriesRouteWithChildren
  CsvImportRoute: typeof CsvImportRoute
  DashboardRoute: typeof DashboardRoute
  FixedExpensesRoute: typeof FixedExpensesRoute
  IncomeSourcesRoute: typeof IncomeSourcesRoute
  InviteRoute: typeof InviteRoute
  LinkWhatsappRoute: typeof LinkWhatsappRoute
  LoginRoute: typeof LoginRoute
  SettingsRoute: typeof SettingsRoute
  TagsDashboardRoute: typeof TagsDashboardRoute
  TransactionsRoute: typeof TransactionsRoute
  TrendsRoute: typeof TrendsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/trends': {
      id: '/trends'
      path: '/trends'
      fullPath: '/trends'
      preLoaderRoute: typeof TrendsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transactions': {
      id: '/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof TransactionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tags-dashboard': {
      id: '/tags-dashboard'
      path: '/tags-dashboard'
      fullPath: '/tags-dashboard'
      preLoaderRoute: typeof TagsDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/link-whatsapp': {
      id: '/link-whatsapp'
      path: '/link-whatsapp'
      fullPath: '/link-whatsapp'
      preLoaderRoute: typeof LinkWhatsappRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/income-sources': {
      id: '/income-sources'
      path: '/income-sources'
      fullPath: '/income-sources'
      preLoaderRoute: typeof IncomeSourcesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fixed-expenses': {
      id: '/fixed-expenses'
      path: '/fixed-expenses'
      fullPath: '/fixed-expenses'
      preLoaderRoute: typeof FixedExpensesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/csv-import': {
      id: '/csv-import'
      path: '/csv-import'
      fullPath: '/csv-import'
      preLoaderRoute: typeof CsvImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/categories': {
      id: '/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof CategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cashflow': {
      id: '/cashflow'
      path: '/cashflow'
      fullPath: '/cashflow'
      preLoaderRoute: typeof CashflowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/budgets': {
      id: '/budgets'
      path: '/budgets'
      fullPath: '/budgets'
      preLoaderRoute: typeof BudgetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-chat': {
      id: '/ai-chat'
      path: '/ai-chat'
      fullPath: '/ai-chat'
      preLoaderRoute: typeof AiChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/categories/analysis': {
      id: '/categories/analysis'
      path: '/analysis'
      fullPath: '/categories/analysis'
      preLoaderRoute: typeof CategoriesAnalysisRouteImport
      parentRoute: typeof CategoriesRoute
    }
  }
}

interface CategoriesRouteChildren {
  CategoriesAnalysisRoute: typeof CategoriesAnalysisRoute
}

const CategoriesRouteChildren: CategoriesRouteChildren = {
  CategoriesAnalysisRoute: CategoriesAnalysisRoute,
}

const CategoriesRouteWithChildren = CategoriesRoute._addFileChildren(
  CategoriesRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AiChatRoute: AiChatRoute,
  BudgetsRoute: BudgetsRoute,
  CashflowRoute: CashflowRoute,
  CategoriesRoute: CategoriesRouteWithChildren,
  CsvImportRoute: CsvImportRoute,
  DashboardRoute: DashboardRoute,
  FixedExpensesRoute: FixedExpensesRoute,
  IncomeSourcesRoute: IncomeSourcesRoute,
  InviteRoute: InviteRoute,
  LinkWhatsappRoute: LinkWhatsappRoute,
  LoginRoute: LoginRoute,
  SettingsRoute: SettingsRoute,
  TagsDashboardRoute: TagsDashboardRoute,
  TransactionsRoute: TransactionsRoute,
  TrendsRoute: TrendsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
